import { Link } from 'react-router-dom';
import { useLang } from '@/contexts/LanguageContext';
import GoldenSpiral from '@/components/effects/GoldenSpiral';

export default function NotFound() {
  const { t } = useLang();

  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <GoldenSpiral size={500} className="animate-spiral-rotate" opacity={0.06} />
      </div>
      <div className="text-center relative z-10">
        <h1 className="text-6xl sm:text-8xl font-display text-sacred-gold/30 mb-4">404</h1>
        <p className="text-2xl sm:text-3xl font-display text-heading mb-3" data-testid="not-found-title">{t('notFound.title')}</p>
        <p className="text-text-muted font-body mb-10 max-w-md mx-auto">{t('notFound.subtitle')}</p>
        <Link to="/" className="gold-button px-8 py-3 rounded-full font-body inline-block" data-testid="return-home-btn">
          {t('notFound.cta')}
        </Link>
      </div>
    </div>
  );
}
